
import { Button, Dialog, DialogActions, DialogContent, DialogTitle} from "@mui/material";
import React, { useState, useEffect, Fragment, useMemo } from "react";

interface TermsAndConditionProps {
    open: boolean;    
    handleClose: () => void;
}

export default function TermsAndCondition({open,handleClose}:TermsAndConditionProps) {
  return (
    <Fragment>
      <Dialog open={open} onClose={handleClose}>
        <DialogTitle>Terms & Conditions</DialogTitle>
        {/* <DialogContent>                                                */}            
            <iframe src="./TOS.pdf" width={500} height={350} />                                                                                      
        {/* </DialogContent> */}
        <DialogActions>
          <Button variant="outlined" onClick={handleClose}>
            Ok
          </Button>
        </DialogActions>
      </Dialog>
    </Fragment>
  )
}